<!-- 资源使用滑块组件 -->
<template>
  <div class="w-full">
    <div class="h-6 bg-gray-200 rounded-xl overflow-hidden relative">
      <!-- 背景网格，增强科技感但保持扁平 -->
      <div class="absolute inset-0 opacity-[0.08] pointer-events-none">
        <div
          class="w-full h-full bg-[radial-gradient(circle_at_1px_1px,rgba(0,0,0,0.4)_1px,transparent_1px)] [background-size:10px_10px]"
        ></div>
      </div>

      <!-- 已用进度 -->
      <div
        class="h-full transition-all duration-300 ease-linear absolute top-0 left-0 flex items-center px-1 z-10"
        :class="getColorClass().bar"
        :style="{ width: `${percentage}%` }"
      >
        <span
          class="text-[9px] font-semibold whitespace-nowrap"
          :class="getColorClass().text"
          >{{ label }}:
          <!--{{ percentage.toFixed(0) }}%--></span
        >
        <span
          class="text-[9px] font-semibold whitespace-nowrap"
          :class="getColorClass().text"
        >
          <span v-if="props.usedCustomLabel">
            {{ props.usedCustomLabel }}
          </span>
          <span v-else>{{ formatNumber(used) }}{{ unit }}</span>
          /
          <span v-if="props.totalCustomLabel">
            {{ props.totalCustomLabel }}
          </span>
          <span v-else>{{ formatNumber(total) }}{{ unit }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  label: string
  used: number | string
  total: number | string
  unit?: string
  type?: 'cpu' | 'memory' | 'default'
  usedCustomLabel?: string | number
  totalCustomLabel?: string | number
}

const props = withDefaults(defineProps<Props>(), {
  unit: '',
  type: 'default'
})

const percentage = computed(() => {
  const usedNum =
    typeof props.used === 'string' ? parseFloat(props.used) : props.used
  const totalNum =
    typeof props.total === 'string' ? parseFloat(props.total) : props.total
  return totalNum > 0 ? (usedNum / totalNum) * 100 : 0
})

// 格式化数字，保留最多两位小数，去掉多余的零
const formatNumber = (v: number | string | undefined | null) => {
  if (v === undefined || v === null) return ''
  const n = typeof v === 'string' ? parseFloat(v) : v
  if (Number.isNaN(n as number)) return String(v)
  // 使用 toFixed(2) 后去掉多余的 0
  return (n as number).toFixed(2).replace(/\.0+$|(?<=\.[0-9]*[1-9])0+$/g, '')
}

// 如果需要显示百分比，可使用 formatNumber(percentage.value)

const getColorClass = () => {
  const percent = percentage.value

  if (percent >= 90) {
    return { bar: 'bg-red-500', text: 'text-gray-900' }
  } else if (percent >= 75) {
    return { bar: 'bg-orange-500', text: 'text-gray-900' }
  } else if (percent >= 50) {
    return { bar: 'bg-yellow-500', text: 'text-gray-900' }
  } else {
    return { bar: 'bg-green-500', text: 'text-gray-900' }
  }
}
</script>

<style scoped></style>
